import { toast } from "react-toastify";
import Api from "../../../axios";
import { callLoader } from "../../../common/actions/app";

let ACTION_USER_COMPANY_LIST = {
    type: 'USER_COMPANY_LIST',
    payload: {
        rows: [],
        total: 0,
        pagination: [],
    },
};

let callUserCompanyListGet = (userId, filter = {}, pg = 1) => (dispatch) => {
    dispatch(callLoader(true))
    Api.get('/user-companies/' + userId + '?pg=' + pg).then((data) => {
        dispatch(callLoader(false))
        if (!data)
            return

        ACTION_USER_COMPANY_LIST.payload.rows = data.rows
        ACTION_USER_COMPANY_LIST.payload.total = data.total
        ACTION_USER_COMPANY_LIST.payload.pagination = data.pagination
        dispatch(ACTION_USER_COMPANY_LIST)
    })
}

let callUserCompanyPost = (userId, data, success = () => { }) => (dispatch) => {
    dispatch(callLoader(true))
    Api.post('/user-companies/' + userId, data).then((data) => {
        dispatch(callLoader(false))
        if (!data)
            return

        toast.success(data.msg)
        success()
    })
}

let callUserCompanyDelete = (userId, id, success = () => { }) => (dispatch) => {
    dispatch(callLoader(true))
    Api.delete('/user-companies/' + userId + '/' + id).then((data) => {
        dispatch(callLoader(false))
        if (!data)
            return

        toast.success(data.msg)
        success()
    })
}

export { callUserCompanyListGet, callUserCompanyPost, callUserCompanyDelete, ACTION_USER_COMPANY_LIST }